import { escapeHtml, formatEmailBodyHtml, normalizeEmailCopyInput, } from './emailCopyFormatting.js';
export const DEFAULT_EMAIL_SUPPORT_EMAIL = 'help@blocktickets.xyz';
export const DEFAULT_EMAIL_HELP_FOOTER_SUFFIX = 'and we will get back to you shortly!';
/**
 * Builds the global help footer shown at the bottom of customer-facing emails.
 */
export function buildEmailHelpFooter(options) {
    const email = String(options?.supportEmail ?? '').trim() || DEFAULT_EMAIL_SUPPORT_EMAIL;
    const custom = normalizeEmailCopyInput(options?.customFooter);
    if (custom) {
        return {
            emailSupportEmail: email,
            emailHelpFooterText: custom,
            emailHelpFooterHtml: formatEmailBodyHtml(custom),
        };
    }
    const safeEmail = escapeHtml(email);
    const text = `Need help? Email ${email} ${DEFAULT_EMAIL_HELP_FOOTER_SUFFIX}`;
    const html = `Need help? Email <a rel="noopener" href="mailto:${encodeURIComponent(email)}?subject=Help" target="_blank">${safeEmail}</a> ${DEFAULT_EMAIL_HELP_FOOTER_SUFFIX}`;
    return {
        emailSupportEmail: email,
        emailHelpFooterText: text,
        emailHelpFooterHtml: html,
    };
}
